import { createContext } from 'react';

export const SettingsDrillContext = createContext<{
  page: string | null;
  host: HTMLDivElement | null;
  open(page: string): void;
  back(): void;
} | null>(null);
